<template>
    <div class="creative-preview">
        <a
            v-if="creative.link"
            :href="creative.link"
            target="_blank"
            class="linkwrap"
        >
            <div class="blocker" v-if="creative.type === 'image'"></div>
            <iframe
                v-if="creative.preview"
                :src="creative.preview"
                :width="creative.width + 'px'"
                :height="creative.height + 'px'"
                title="Creative Preview"
                class="iframe"
            >
            </iframe>
        </a>
    </div>
</template>

<script>
export default {
    name: "CreativePreview",
    props: {
        creative: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.creative-preview {
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    .linkwrap {
        position: relative;
        display: inline-block;
    }

    .blocker {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 1;
    }

    .iframe {
        z-index: 2;
        border: none;
    }
}
</style>
